/* eslint-disable @typescript-eslint/no-unused-vars */
import { EditorStore } from '../editor';
import { NodeId, NodeTree } from '../interfaces';
import React from 'react';
import { EventHandlers } from '../utils/EventHandlers';

export interface CreateHandlerOptions {
    onCreate: (nodeTree: NodeTree) => void;
}

export interface CreateHandlerOptions {
    onCreate: (nodeTree: NodeTree) => void;
}

export class CoreEventHandlers<O = Record<string, unknown>> extends EventHandlers<{ store: EditorStore } & O> {
    handlers() {
        return {
            connect: (el: HTMLElement, id: NodeId) => {
                //EMPTY
            },
            select: (el: HTMLElement, id: NodeId) => {
                //EMPTY
            },
            hover: (el: HTMLElement, id: NodeId) => {
                //EMPTY
            },
            drag: (el: HTMLElement, id: NodeId) => {
                //EMPTY
            },
            drop: (el: HTMLElement, id: NodeId) => {
                //EMPTY
            },
            create: (
                el: HTMLElement,
                UserElement: React.ReactElement | (() => NodeTree | React.ReactElement),
                options?: Partial<CreateHandlerOptions>,
            ) => {
                //EMPTY
            },
        };
    }
}
